import { EPublisherSolutionModel } from 'common/contracts';
import { localStorageUtil } from 'utils/localStorageUtil';
import { EPlayersState } from 'views/Players/PlayersView';
import { EPricingFormState } from 'views/Pricing/PricingView';
import { EReportsTabs } from 'views/Reports/types';

import { ESettingsState } from 'components/Settings/Settings.types';
import { EStoreState } from 'components/Theme/Theme';

import { ELocalStorageKeys } from './enums';

export enum EOrdersState {
  ORDERS = 'orders',
  FREE_ORDERS = 'freeOrders'
}

const isCheckoutUser =
  localStorageUtil.get(ELocalStorageKeys.PUBLISHER_SOLUTION_MODEL) ===
  EPublisherSolutionModel.CHECKOUT;

export const settingTabsLabelsMap: Record<ESettingsState, string> = {
  [ESettingsState.COMPANY]: 'Company',
  [ESettingsState.USERS]: 'Users',
  [ESettingsState.INTEGRATION]: 'Integration',
  [ESettingsState.PROFILES]: 'Profiles',
  [ESettingsState.PLAYER_AUTH]: 'Authentication',
  [ESettingsState.PAYMENTS]: 'Payments',
  [ESettingsState.ENCRYPTION]: 'Encryption',
  [ESettingsState.LAYOUT]: 'Layout',
  [ESettingsState.EVENTS]: 'Events Center',
  [ESettingsState.STORE_SETTINGS]: 'Store Settings',
  [ESettingsState.PORTAL]: 'Portal',
  [ESettingsState.DEFAULT]: 'Default'
};

export const themeTabsLabelsMap: Record<EStoreState, string> = {
  [EStoreState.GENERAL]: 'General Settings',
  [EStoreState.STORE]: 'Store Page',
  [EStoreState.LOGIN]: 'Login Page',
  [EStoreState.ACCOUNT_APPROVAL_MODAL]: 'Account Approval Modal',
  [EStoreState.CHECKOUT]: 'Checkout Page',
  [EStoreState.COMPLETED]: 'Completed Page',
  [EStoreState.RECEIPT]: 'Receipt'
};

export const pricingTabsLabelsMap: Record<EPricingFormState, string> = {
  [EPricingFormState.PRICING_POINTS]: 'Price Points',
  [EPricingFormState.SETTINGS]: 'Settings'
};

export const ordersTabsLabelsMap: Record<EOrdersState, string> = {
  [EOrdersState.ORDERS]: 'Paid Orders',
  [EOrdersState.FREE_ORDERS]: 'Free Orders'
};

export const reportsTabsLabelsMap: Record<EReportsTabs, string> = {
  [EReportsTabs.FINANCIAL]: 'Financial',
  [EReportsTabs.PAYOUTS]: 'Payouts'
};

export const playersTabsLabelsMap: Record<EPlayersState, string> = {
  [EPlayersState.BLOCKED]: 'Blocked players'
};
